module.exports = __webpack_public_path__ + "img/fruit-grapefruit-350x184.3ee59be6.jpg";